module.exports = __webpack_public_path__ + "img/icn-change.d1a31ba4.svg";